module.exports = __webpack_public_path__ + "img/vgt_bg.d5c71557.png";